// FILTER PAGE
//==============

// cache global & much used references
let $doc = $(document),
  $window = $(window),
  $body = $("body"),
  $searchBtn = $("#search-button"),
  obj = decodeUrl(document.location.search) || {}, // Create empty object to store the filters and create the url from
  searchUrl = {},
  returnUrl = {},
  $currentModalFilter = "";
var template;

$doc.ready(function(jQuery) {
  if (
    $body.hasClass("filter-page") ||
    $body.hasClass("page-template-publicaties")
  ) {
    template = twig({
      id: "filter-options",
      href: KWR.view + "parts/filter-options.twig",
      async: true,
      load: function(template) {
        $body.addClass("js-template-loaded");
      },
    });
  }
});

/*----------------------------------*\
||    2.0   Functions               ||
\*----------------------------------*/

function createReturnUrl() {
  // return object;
  return document.location.search;
}

/**
 * gets the correct key of an object
 * @param    o    object  - Object to sort through
 * @param    r    regex   - Regular Expression
 * @return   key  string  - The requested key
 **/

function findProperty(o, r) {
  var key;
  for (key in o) {
    if (key.match(r)) {
      return key;
    }
  }
  return undefined;
}

/**
 * Turns the filter object into an usable url
 * @param    object  - Object to transform
 * @return   _url    - searchquery url
 **/

function toUrl(object) {
  // var _url = JSON.stringify(object),

  // // Create a lot of regular expressions
  // reg1 = new RegExp("(\",\")", "g"),  // first remove the [","] some filters have comma's in them so we need to be more specific or else these filters get broken
  // reg2 = new RegExp("([{}\"])", "g"), // then remove all other characters such as }, {, and "
  // reg4 = new RegExp("(:)", "g");      // then replace all : with = to turn &filter:value into &filter=value

  // if (_url) {
  //    // Replace a lot of stuff with regular expressions
  //    _url = _url.replace(reg1, '');
  //    _url = _url.replace(reg2, '');
  //    _url = _url.replace(/(search\/:)/g, 'search/');
  //    _url = _url.replace(reg4, '=');

  //    return _url;
  // } else {
  //    return false;
  // }
  return (
    "?" +
    Object.keys(object).reduce((string, key) => {
      let value = object[key];

      if (Array.isArray(value)) value = value.join(";");

      if (string) string += "&";

      return string + key + "=" + value;
    }, "")
  );
}

// Returns object of URL

function decodeUrl(_url) {
  if (typeof _url === "string" && _url !== "") {
    return _url
      .replace(/^\?/, "")
      .split("&")
      .reduce((data, i) => {
        i = i.split("=");
        data[i[0]] = decodeURI(i[1]);
        return data;
      }, {});
    // return JSON.parse(
    //   '{"' +
    //   decodeURI(_url)
    //     .replace('?', '')
    //     .replace(/"/g, '\\"')
    //     .replace(/&/g, '","')
    //     .replace(/%2C/g,",")
    //     .replace(/=/g, '":"') +
    //   '"}'
    // );
  }
}

// function decodeUrlToObj(_url) {
//   if (typeof _url === 'string' && _url !== ''){
//     return _url.split('&')
//     .reduce((data, item) => {
//       item = item.split('=');

//       const key = item[0]

//       data[key] = decodeURI(item[1]);
//       return data;
//     }, {});
//   }
// }

/**
 * Turns the filter term into a slug
 * @param    string  - String that needs to be slugified
 * @return   lcs     - lowercase version of string with all whitespaces replaced with dashes
 **/

function toSlug(string) {
  var lcs = string
    .toLowerCase()
    .replace(/( )+/g, "-")
    .replace(/[.,&\/;]+/g, "");

  return lcs;
}

/**
 * Adds a filter to the chosen filters list, searchbutton url and as activated filter to the current url
 * @param filterGroup        string  - Class of the filter group
 * @param filterTerm         string  - filter to be added
 * @param add_to_current_url boolean - Whether or not this one needs to be added to the current url containing all activated filters (if true in the wrong places can cause an infinite loop)
 **/

function addFilter(filterGroup, filterTerm, add_to_current_url, clear = false) {
  filterTerm = encodeURIComponent(filterTerm);

  if (Object.keys(obj).length === 0 && obj.constructor === Object) {
    // If there is nothing inside the object
    obj[filterGroup] = filterTerm;
  } else {
    // When there is something inside the object
    if (obj.hasOwnProperty(filterGroup)) {
      // If there already is a property for this term

      let array = obj[filterGroup].split("%3B");

      if (clear) {
        array = [filterTerm];
      } else {
        array.push(filterTerm);
      }
      array = array.join("%3B");

      obj[filterGroup] = array;
    } else {
      // When it's a new property
      obj[filterGroup] = filterTerm;
    }

    console.log({ obj });
  }

  $(document).trigger("filterHasChanged", [obj]);

  if (add_to_current_url) {
    var query = toUrl(obj);

    var _url = KWR.publicationFilterPage + query;

    if (location.pathname.includes("filter")) {
      window.history.pushState(
        "",
        "Filter",
        document.location.protocol +
          "//" +
          document.location.host +
          location.pathname +
          query
      ); // Apply the new url
    } else {
      window.history.pushState(
        "",
        "Filter",
        document.location.protocol +
          "//" +
          document.location.host +
          location.pathname +
          "filter/" +
          query
      ); // Apply the new url
    }
    reloadFilters();
  }
}

/**
 * Adds a filter to the chosen filters list, searchbutton url and as activated filter to the current url
 * @param filterGroup    string      - Class of the filter group
 * @param filterTerm  string      - filter to be removed
 * @param filterId       string      - id of the filter to be removed (an sanitized version of the key)
 **/

function removeFilter(filterGroup, filterTerm, filterId) {
  var items = decodeURIComponent(obj[filterGroup]).split(";");

  var group = filterGroup,
    term = decodeURIComponent(filterTerm),
    slug = toSlug(decodeURIComponent(term));

  var remove = items.findIndex(i => i == term);
  if (-1 < remove) {
    items.splice(remove, 1);
  }

  obj[group] = items.filter(i => i).join(";");

  if (obj[group] === "") {
    delete obj[group];
  }

  // if first key with '?' was deleted we need to add '?' to new first key
  // this weird manipulation is needed to make sure key with '?' always will be first.
  if (group.indexOf("?") !== -1) {
    var tempUrl = toUrl(obj);
    if (tempUrl.charAt(0) == "&") {
      tempUrl = tempUrl.replace("&", "?");
      obj = JSON.parse(
        '{"' +
          tempUrl
            .replace(/"/g, '\\"')
            .replace(/&/g, '","&')
            .replace(/=/g, '":"') +
          '"}'
      );
    }
  }

  var _url = toUrl(obj);

  // Remove the filter tags
  $("#" + slug).removeClass("selected");
  $('[data-rel="' + slug + '"]').remove();

  // Remove the filter from the urls
  window.history.pushState(
    "",
    "Filter",
    document.location.protocol +
      "//" +
      document.location.host +
      location.pathname +
      _url
  ); // Apply the new url
  $searchBtn.attr("href", KWR.publicationFilterPage + _url); // Replace url of searchbutton

  $(document).trigger("filterHasChanged", [obj]);

  reloadFilters();
}

/**
 * Reload the filter with the contextual filters
 **/
function reloadFilters() {
  return pubFilter._getPublications();
}

/**
 * Opens modal with list of filters for teh respective group
 * @param type string - filter group name - required
 * @param value string - string to filter group array - optional
 **/

function displayModalContent(type, value) {
  let modalContent = "";

  if (type == "year" || type == "document_type") {
    let list = Twig.twig({ ref: "filter-options" }).render({
      filters: $filters[type],
    });

    let lastItems = $filters[type].length % 4;
    modalContent =
      modalContent +
      `<div class="striped-item">
                          <ul class="bordered-list last-${lastItems}">${list}</ul>
                        </div>`;
  } else {
    let groupedContent = $filters[type].reduce(function(grouped, item) {
      if (value) {
        if (item.key.toLowerCase().includes(value.toLowerCase())) {
          grouped[item.key.charAt(0).toUpperCase()] =
            grouped[item.key.charAt(0).toUpperCase()] || [];
          grouped[item.key.charAt(0).toUpperCase()].push(item);
        }
      } else {
        grouped[item.key.charAt(0).toUpperCase()] =
          grouped[item.key.charAt(0).toUpperCase()] || [];
        grouped[item.key.charAt(0).toUpperCase()].push(item);
      }
      return grouped;
    }, {});
    Object.keys(groupedContent).forEach(function(key) {
      let list = Twig.twig({ ref: "filter-options" }).render({
        filters: groupedContent[key],
      });

      let lastItems = groupedContent[key].length % 4;
      modalContent =
        modalContent +
        `<div class="striped-item">
                          <span class="letter like-h2">${key}</span>
                          <ul class="bordered-list margin-top last-${lastItems}">${list}</ul>
                        </div>`;
    });
  }
  $(".striped-content").html(modalContent);
  if (type == "year" || type == "document_type") {
    $("#filter-search").addClass("hide");
  } else {
    $("#filter-search").removeClass("hide");
  }
  $("#filterModal").foundation("open");
  $(".scroll-area").perfectScrollbar({
    suppressScrollX: true,
  });
}

String.prototype.trunc =
  String.prototype.trunc ||
  function(n) {
    return this.length > n ? this.substr(0, n - 1) + "&hellip;" : this;
  };

function setReturnUrl(obj) {
  if (obj) {
    $("#filter-return-link").attr("href", KWR.publicationFilterPage + obj);
  } else {
    $("#filter-return-link").attr("href", KWR.publicationFilterPage);
  }
}

/*----------------------------------*\
||    2.0   Events                  ||
\*----------------------------------*/

$doc.ready(
  (function(jQuery) {
    if ($("body").hasClass("filter-page")) {
      setReturnUrl(createReturnUrl());

      /**
       *  On click:
       *  Add filter to chosen filters
       *  Set filter to active/selected
       **/

      $doc.on("click", ".filter-group .tag", function() {
        var id = $(this).attr("id"),
          text = $(this).text(),
          key = $(this).attr("data-key"),
          theClass = $(this)
            .parents(".filter-group")
            .data("type");

        //  theClass = $(this).closest('.filter-options-list').prev().attr('class').split(' ')[1], // That's a lot of parents! :/ (This is due to the custom scrollbar html that's injected)
        //  searchUrl = $searchBtn.attr('href');

        if (!$(this).hasClass("selected")) {
          // add class selected to clicked item
          $(this).addClass("selected");

          addFilter(theClass, key, true);
        } else {
          removeFilter(theClass, encodeURIComponent(key), id);
        }
      });

      // $(".filter-group").on("click", ".tag", function() {

      // });

      /**
       *  On click:
       *  Remove filter from chosen filters.
       *  Remove the filter from the URL
       *  Remove the filter from the Search button's URL
       **/
      $(".chosen-filters").on("click", ".tag", function() {
        var _this = $(this),
          rel = _this.attr("data-rel"), //value
          group = _this.data("group"), //filter group
          relTag = $(".filter-group ." + group + "-list  #" + rel),
          value = encodeURIComponent(rel);

        if (relTag.length) {
          relTag.removeClass("selected");
          value = encodeURIComponent(relTag.data("key"));
        }
        removeFilter(group, value, rel);
        _this.remove();
      });
    }

    /**
     *  Functions to open modal and filter stuff when using the modal window
     **/

    // Open modal
    $doc.on("click", ".js-open-filter-modal", function() {
      const content = $(this).data("content"),
        title = $(this)
          .parents(".filter-group")
          .children(".filter-title")
          .html();

      displayModalContent(content, false);
      $(".modal-title").html(title);
      $(".filter-content").data("type", content);
      $currentModalFilter = $(".filter-content .selected").attr("data-key");
    });

    // Select tag inside modal
    $doc.on("click", ".filter-content .filter-option", function() {
      $(this)
        .children(".tag")
        .toggleClass("selected");
    });

    // Filter modal content
    $doc.on("keyup", "#filter-search", function(e) {
      let value = this.value;
      let modalType = $(".filter-content").data("type");
      displayModalContent(modalType, value);
      this.focus();
    });

    $doc.on("click", ".js-filter-button", e => {
      const selected = document.querySelectorAll(".filter-content .selected"),
        type = $(".filter-content").data("type");

      const keys = Object.keys(selected)
        .map(key => {
          return selected[key].getAttribute("data-key");
        })
        .filter(k => k);

      if (keys.length) {
        addFilter(type, keys.join(";"), true, true);
      } else {
        if (search) {
          removeFilter(
            type,
            encodeURIComponent($currentModalFilter),
            toSlug($currentModalFilter)
          );
        }
      }
      $("#filterModal").foundation("close");
    });
  })(jQuery, window, document)
);
